import Bloom from './Bloom';

export default {
  pre() {
    return (
      <Bloom />
    );
  },
};